import { Icon } from '@iconify/react';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import useLocales from 'hooks/useLocales';

export const COLORS = {
    default: '#EDEFF2',
    present: '#4caf50',
    absent: '#FF365A',
    late: '#FFC444',
    leftEarly: '#3A89FF',
};

export const ICONS = {
    present: <Icon icon='ic:outline-check-circle' width='16' height='16' color='white' />,
    absent: <Icon icon='ic:outline-cancel' width='16' height='16' color='white' />,
    late: <Icon icon='ic:outline-access-time' width='16' height='16' color='white' />,
    leftEarly: <Icon icon='ic:outline-exit-to-app' width='16' height='16' color='white' />,
};

export const AttendanceReportLegend = () => {
    const { translate } = useLocales();

    return (
        <Stack direction='row' justifyContent='center' alignItems='center' sx={{ p: 2 }} spacing={3}>
            <Stack direction='row' alignItems='center' spacing={1}>
                <Box
                    sx={{
                        background: COLORS.present,
                        borderRadius: 0.25,
                        width: '18px',
                        height: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {ICONS.present}
                </Box>
                <Typography variant='body2'>- {translate('present')}</Typography>
            </Stack>
            <Stack direction='row' alignItems='center' spacing={1}>
                <Box
                    sx={{
                        background: COLORS.absent,
                        borderRadius: 0.25,
                        width: '18px',
                        height: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {' '}
                    {ICONS.absent}
                </Box>
                <Typography variant='body2'>- {translate('absent')}</Typography>
            </Stack>
            <Stack direction='row' alignItems='center' spacing={1}>
                <Box
                    sx={{
                        background: COLORS.late,
                        borderRadius: 0.25,
                        width: '18px',
                        height: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {ICONS.late}
                </Box>
                <Typography variant='body2'>- {translate('late')}</Typography>
            </Stack>
            <Stack direction='row' alignItems='center' spacing={1}>
                <Box
                    sx={{
                        background: COLORS.leftEarly,
                        borderRadius: 0.25,
                        width: '18px',
                        height: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {ICONS.leftEarly}
                </Box>
                <Typography variant='body2'>- {translate('left_early')}</Typography>
            </Stack>
        </Stack>
    );
};
